// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"77b828216a354562","src_app_bulk-user-update_bulk-user-update_module_ts":"d88ce84fd9ac94b3"}[chunkId] + ".js";
};